import { render, staticRenderFns } from "./KPIDetail.vue?vue&type=template&id=537f9b82&scoped=true&"
import script from "./KPIDetail.vue?vue&type=script&lang=ts&"
export * from "./KPIDetail.vue?vue&type=script&lang=ts&"
import style0 from "./KPIDetail.vue?vue&type=style&index=0&id=537f9b82&prod&scoped=true&lang=css&"
import style1 from "./KPIDetail.vue?vue&type=style&index=1&id=537f9b82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537f9b82",
  null
  
)

export default component.exports